<div class="bottom-sheet-shell">
    <div class="bottom-sheet-shell-handle-wrap">
        <div class="bottom-sheet-shell-handle"></div>
    </div>

    <div class="bottom-sheet-shell-header">
        <span class="bottom-sheet-shell-title title-large">{{ title }}</span>

        <button
            matIconButton
            type="button"
            class="bottom-sheet-shell-close"
            [attr.aria-label]="'designSystem.ui.chiudi' | transloco"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="bottom-sheet-shell-content">
        <ng-content select="[bottom-sheet-content]"></ng-content>
    </div>

    <div class="bottom-sheet-shell-footer">
        <ng-content select="[bottom-sheet-footer]"></ng-content>
    </div>
</div>
